"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
const tslib_1 = require("tslib");
class Preview {
    constructor(repository) {
        this.repository = repository;
    }
    regenerate(options) {
        var _a;
        return this.repository.executeAction({
            name: 'RegeneratePreviews',
            idOrPath: options.idOrPath,
            method: 'POST',
            body: undefined,
            requestInit: {
                signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
            },
        });
    }
    available(options) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const responseBody = yield this.repository.executeAction({
                idOrPath: options.document.idOrPath,
                method: 'POST',
                name: 'PreviewAvailable',
                oDataOptions: {
                    version: options.version,
                },
                body: {
                    page: options.page,
                },
                requestInit: {
                    signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
                },
            });
            if (responseBody.PreviewAvailable) {
                responseBody.PreviewImageUrl = `${options.document.hostName}${responseBody.PreviewAvailable}`;
                responseBody.ThumbnailImageUrl = `${options.document.hostName}${responseBody.PreviewAvailable.replace('preview', 'thumbnail')}`;
                return responseBody;
            }
        });
    }
    getExistingImages(options) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (options.document.pageCount < -1) {
                throw Error('Preview generation error');
            }
            const response = yield this.repository.executeAction({
                idOrPath: options.document.idOrPath,
                name: `GetExistingPreviewImages`,
                method: 'POST',
                body: {},
                oDataOptions: {
                    select: 'all',
                    expand: 'all',
                    version: options.version,
                },
                requestInit: {
                    signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
                },
            });
            const availablePreviews = response.map((preview) => {
                if (preview.PreviewAvailable) {
                    preview.PreviewImageUrl = `${options.document.hostName}${preview.PreviewAvailable}`;
                    preview.ThumbnailImageUrl = `${options.document.hostName}${preview.PreviewAvailable.replace('preview', 'thumbnail')}`;
                }
                return preview;
            });
            const allPreviews = [];
            for (let i = 0; i < options.document.pageCount; i++) {
                allPreviews[i] = availablePreviews[i] || { Index: i + 1 };
            }
            return allPreviews;
        });
    }
    getPageCount(options) {
        var _a;
        return this.repository.executeAction({
            idOrPath: options.idOrPath,
            name: 'GetPageCount',
            method: 'POST',
            requestInit: {
                signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
            },
        });
    }
    check(options) {
        var _a;
        return this.repository.executeAction({
            idOrPath: options.idOrPath,
            name: 'CheckPreviews',
            method: 'POST',
            body: {
                generateMissing: options.generateMissing,
            },
            requestInit: {
                signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
            },
        });
    }
    getComments(options) {
        var _a;
        return this.repository.executeAction({
            idOrPath: options.idOrPath,
            name: 'GetPreviewComments',
            method: 'GET',
            oDataOptions: {
                page: options.page,
            },
            requestInit: {
                signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
            },
        });
    }
    addComment(options) {
        var _a;
        return this.repository.executeAction({
            idOrPath: options.idOrPath,
            name: 'AddPreviewComment',
            method: 'POST',
            body: options.comment,
            requestInit: {
                signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
            },
        });
    }
    deleteComment(options) {
        var _a;
        return this.repository.executeAction({
            idOrPath: options.idOrPath,
            name: 'DeletePreviewComment',
            method: 'POST',
            body: {
                id: options.commentId,
            },
            requestInit: {
                signal: (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal,
            },
        });
    }
}
exports.Preview = Preview;
//# sourceMappingURL=Preview.js.map